class ContactMatchController {
  constructor(authService, userService, loadingService, $scope) {
    "ngInject";

    this.authService = authService;
    this.userService = userService;
    this.loadingService = loadingService;

    this.contactVehicleSalesMatches = [];
    this.selectedContact = null;

    this.params = {};

    $scope.$on('dashboard:viewContactMatches', this.viewContactMatches.bind(this));

    this.stats = {
      contactToVehicleCount: 0,
      vehicleToContactCount: 0
    }
  }

  viewContactMatches(evt, params) {
    const ctrl = this;

    ctrl.params = params || ctrl.params;

    ctrl.loadingService.showLoading('contactMatchList', 'Loading Matches');

    ctrl.selectedContact = null;

    ctrl.userService.salesMatches(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), ctrl.params.userId)
      .then(response => {
        ctrl.contactVehicleSalesMatches = response.data.contactVehicleSalesMatches;
        if (ctrl.contactVehicleSalesMatches.length) {
          ctrl.selectedContact = ctrl.contactVehicleSalesMatches[0];
        }

        ctrl.onLoad({count: ctrl.contactVehicleSalesMatches.length});
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('contactMatchList');
      });
  }
}

export default ContactMatchController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/contactMatch/contactMatch.controller.js